import {GetWidgetConfig} from '../Vendors/SizerAppAPI';
let sizer_theme = null;

function getTheme(){
    if(sizer_theme){
        return sizer_theme;
    }else{
        let themeName = GetWidgetConfig().theme;
        const urlQuery = new URLSearchParams(document.location.search)
        const theme_quary =urlQuery.get('theme');
        if(theme_quary) themeName = theme_quary;

        switch (themeName) {
            case 'barrier':  sizer_theme = 'barrier'; break;
            case 'geltex':  sizer_theme = 'geltex'; break;
            case 'dorina':  sizer_theme = 'dorina'; break;
        
          // case 'pcami':
          //   sizer_theme = 'pcami';
          //   break;
          
          case 'triumph':
            sizer_theme = 'triumph';
            break;

            case 'wacoal':
            sizer_theme = 'wacoal';
            break;
        
            case 'zyler':
            sizer_theme = 'zyler';
            break;
        
            default:
            sizer_theme = 'default';
            break;
        }
        return sizer_theme;

    }
}

export default getTheme;